/* eslint-disable */
import api from "./api";
import entities from "./entities";
import notification from "./notification";
import util from "./util";

function API() {
  return api;
}

function Entities() {
  return entities;
}

function Notification() {
  return notification;
}

function Util() {
  return util;
}

export default {
  API,
  Entities,
  Notification,
  Util,
};
